export default __webpack_public_path__ + "static/media/unlock.7dcef9d7.svg";